import styled from 'styled-components'

export const DisclaimerWrapper = styled.div`
  display: flex;
  align-items: center;
  background: white;
  color: black;
  opacity: 0.92;
  margin: 12px;
  border-radius: 25px;
  font-size: 14px;
`

export const DisclaimerLabel = styled.span`
  display: flex;
  align-items: center;
  line-height: 1.2;
  font-weight: ${(props) => props.weight};
  padding-left: ${(props) => props.left};
`
